// main bundle >> main.bundle.js

import Test from './modules/test'

$(function(){
	let $test = $('.test');

	if ($test.length){
		let test = new Test($('.website'));
	}
});

$(function(){
	let $contact = $('.contact');
	if (!$contact.length){
		return false;
	}

	let $form = $contact.find('form');

	$('.contact__submit').on('click', (e) => {
		e.preventDefault();

		let email = $form.find('input[name="email"]').val();
		let data = {
			email: email
		};


		let request = $.ajax({
			'url': '/user/',
			'data': data,
			'method': 'POST'
		});

		request.done((msg) => {
			$('.contact').addClass('contact_okay');
		});

		request.fail(function (jqXHR, textStatus) {
			alert('Произошла ошибка. Пожалуйста, перезагрузите браузер, проверьте соединение с интернетом и попробуйте еще раз.');
		});
	})
});